import {createSlice} from '@reduxjs/toolkit'

const initialHotelAreaState = {
  totalCount: 0,
  hotel_areas: null,
  hotel_area: undefined,
  hotel_areas_dropdown: [],
}

export const HotelAreaSlices = createSlice({
  name: 'hotel_areas',
  initialState: initialHotelAreaState,
  reducers: {
    hotel_area: (state, action) => {
      state.hotel_area = action.payload.hotel_area
    },
    hotel_areas: (state, action) => {
      state.hotel_areas = action.payload.hotel_areas
      state.totalCount = action.payload.total_count
    },
    hotel_areas_dropdown: (state, action) => {
      state.hotel_areas_dropdown = action.payload.hotel_areas
    },
  },
})
